// modals/banners/DeleteBannerModal.js
import React from "react";
import { Modal, Button } from "react-bootstrap";
import { FiAlertTriangle } from "react-icons/fi";

const DeleteBannerModal = ({ show, onHide, onDelete, bannerName }) => {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          <FiAlertTriangle className="text-danger" /> Confirmer la désactivation
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Êtes-vous sûr de vouloir <strong>désactiver</strong> ce slide ?
        <div className="alert alert-warning mt-3">
          <strong>{bannerName || 'Sans légende'}</strong>
        </div>
        <p className="text-muted small">
          Cette action peut être annulée plus tard en le réactivant.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Annuler
        </Button>
        <Button variant="danger" onClick={onDelete}>
          Désactiver
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteBannerModal;